var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7261",
    "data-name": "Group 7261",
    transform: "translate(-404.5 -1044.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(405 1045)",
    fill: "#fff",
    stroke: "#40aeba",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-svgrepo-com",
    d: "M17.662,13.15A4.511,4.511,0,1,1,13.15,8.639,4.511,4.511,0,0,1,17.662,13.15Zm0,0v1.692a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82V13.15A10.15,10.15,0,1,0,13.15,23.3h4.511",
    transform: "translate(417.5 1057.5)",
    fill: "none",
    stroke: "#40aeba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.16b0e882bc1951bf83ff90f892a92a38.svg";
export { ForwardRef as ReactComponent };